import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './Accordion';
import { Check } from 'lucide-react';
const tomosData = [{
  id: 'tomo-1',
  number: '1',
  title: 'Kit de Organización General',
  icon: '🗂️',
  quote: 'Antes de estudiar una sola materia, necesitás un sistema para no perderte en el camino.',
  items: ['Planner semanal y mensual de cursada', 'Cronograma de parciales, finales y entregas de prácticas', 'Plantilla de seguimiento de prácticas de laboratorio', 'Sistema de organización de apuntes por materia', 'Plantilla de gestión de bibliografía y papers']
}, {
  id: 'tomo-2',
  number: '2',
  title: 'Ciclo Básico: Química',
  icon: '⚗️',
  quote: 'Química Orgánica es donde más estudiantes se traban. Acá vas a entenderla de verdad.',
  items: ['Química General e Inorgánica: apuntes completos', 'Química Orgánica: resúmenes y esquemas de mecanismos de reacción', 'Nomenclatura explicada paso a paso', 'Errores más comunes y cómo evitarlos', 'Ejercicios resueltos de práctica']
}, {
  id: 'tomo-3',
  number: '3',
  title: 'Ciclo Básico: Biología y Física',
  icon: '🧬',
  quote: 'La base biológica y física que sostiene todo lo que viene después.',
  items: ['Biología Celular y Molecular: apuntes completos', 'Anatomía y Fisiología: resúmenes por sistema', 'Física aplicada a ciencias biológicas', 'Análisis Matemático: conceptos clave para la carrera', 'Glosario de términos técnicos del ciclo básico']
}, {
  id: 'tomo-4',
  number: '4',
  title: 'Ciclo Intermedio: El Corazón de la Carrera',
  icon: '🔬',
  quote: 'Bioquímica Metabólica es la materia que define la carrera. Este tomo es el más completo del kit.',
  items: ['Físicoquímica: apuntes y resolución de ejercicios tipo', 'Bioquímica Metabólica: mapas completos de vías metabólicas', 'Microbiología: clasificación, identificación y técnicas de cultivo', 'Inmunología: mecanismos explicados sin vueltas', 'Técnicas de memorización específicas para vías metabólicas']
}, {
  id: 'tomo-5',
  number: '5',
  title: 'Ciclo Superior',
  icon: '🧫',
  quote: 'Para cuando ya falta poco y necesitás cerrar fuerte.',
  items: ['Análisis Clínicos: apuntes y casos prácticos', 'Bioestadística: conceptos aplicados a resultados de laboratorio', 'Genética y Biología Molecular: apuntes completos', 'Toxicología: mecanismos y casos', 'Materias de orientación según plan de estudio']
}, {
  id: 'tomo-6',
  number: '6',
  title: 'Recta Final y Diccionario Técnico',
  icon: '⭐',
  quote: 'El cierre del sistema: de saber la materia a rendirla bien.',
  items: ['Glosario técnico completo de la carrera', 'Banco de preguntas tipo parcial y final', 'Guía de técnicas de estudio para grandes volúmenes de contenido', 'Checklist de preparación para mesas de examen', 'Hoja de ruta sugerida cuatrimestre por cuatrimestre']
}];
export function Tomos() {
  const accordionItems = tomosData.map(tomo => ({
    id: tomo.id,
    title: <div className="flex items-center gap-3" data-id="element-246">
        <span className="text-brand-teal font-bold text-lg w-5" data-id="element-247">
          {tomo.number}
        </span>
        <span className="text-white font-semibold flex-1" data-id="element-248">{tomo.title}</span>
        <span className="text-xl" data-id="element-249">{tomo.icon}</span>
      </div>,
    content: <div className="pt-2" data-id="element-250">
        <p className="text-gray-300 italic mb-4 text-sm" data-id="element-251">"{tomo.quote}"</p>
        <ul className="space-y-2" data-id="element-252">
          {tomo.items.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-253">
              <Check className="w-4 h-4 text-brand-tealLight mt-0.5 flex-shrink-0" data-id="element-254" />
              <span data-id="element-255">{item}</span>
            </li>)}
        </ul>
      </div>
  }));
  return <section id="tomos-section" className="bg-brand-dark py-16 px-4 sm:px-6 lg:px-8" data-id="element-256">
      <div className="max-w-2xl mx-auto" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-258">
          <span className="inline-block bg-brand-teal/20 text-brand-tealLight text-xs font-bold px-3 py-1 rounded-full mb-4 border border-brand-teal/30" data-id="element-259">
            📦 Sistema Completo
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-260">
            6 tomos. Toda la carrera. Todo resuelto.
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-261">
            Del ciclo básico a las materias de orientación.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-262">
          <Accordion items={accordionItems} defaultOpenId="tomo-1" className="mb-8" itemClassName="bg-white/5 border-white/10" headerClassName="hover:bg-white/10" contentClassName="border-white/10" data-id="element-263" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-darker rounded-xl p-6 border border-white/10" data-id="element-264">
          <h3 className="text-white font-bold mb-4" data-id="element-265">Cada tomo incluye:</h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-266">
            {['Apuntes claros y completos por materia', 'Esquemas, tablas y mapas conceptuales', 'Resúmenes pensados para repasar rápido antes del parcial', 'Checklist de autoevaluación', '100% enfocado en Bioquímica — sin contenido de otras carreras'].map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-267">
                <Check className="w-4 h-4 text-brand-teal mt-0.5 flex-shrink-0" data-id="element-268" />
                <span data-id="element-269">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}